import { connect } from 'react-redux';
import CardsPay from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(CardsPay);
